import { createSlice } from "@reduxjs/toolkit";
export const assetManagementSlice = createSlice({
  name: "assetManagement",
  initialState: {
    assetManagementData: null,
    selectedSite: null,
    selectedPage: null,
    pageBuilderIsLoading: false,
    pageActionTrigger: 0,
    selectedDate: [],
    selectedOptionStatus: [],
    selectedOptionGroup: [],
    sitePages: [],
    loading: false,
  },
  reducers: {
    setAssetManagementData: (state, action) => {
      state.assetManagementData = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
      // sessionStorage.setItem("selectedSite", action.payload); // Save in session storage
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setPageBuilderIsLoading: (state, action) => {
      state.pageBuilderIsLoading = action.payload;
    },
    setPageActionTrigger: (state, action) => {
      state.pageActionTrigger = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedOptionStatus: (state, action) => {
      state.selectedOptionStatus = action.payload;
    },
    setSelectedOptionGroup: (state, action) => {
      state.selectedOptionGroup = action.payload;
    },
    setSitePages: (state, action) => {
      state.sitePages = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Exporting actions
export const {
  setAssetManagementData,
  setSelectedSite,
  setSelectedPage,
  setPageBuilderIsLoading,
  setPageActionTrigger,
  setSelectedDate,
  setSelectedOptionStatus,
  setSelectedOptionGroup,
  setSitePages,
  setLoading,
} = assetManagementSlice.actions;

// Selector for selectedSite
export const selectSelectedSite = (state: any) =>
  state.assetManagement.selectedSite;
export const selectAssetManagementData = (state: any) =>
  state.assetManagement.assetManagementData;
export const selectSelectedPage = (state: any) =>
  state.assetManagement.selectedPage;
export const selectPageBuilderIsLoading = (state: any) =>
  state.assetManagement.pageBuilderIsLoading;
export const selectPageActionTrigger = (state: any) =>
  state.assetManagement.pageActionTrigger;
export const selectSelectedDate = (state: any) =>
  state.assetManagement.selectedDate;
export const selectSelectedOptionStatus = (state: any) =>
  state.assetManagement.selectedOptionStatus;
export const selectSelectedOptionGroup = (state: any) =>
  state.assetManagement.selectedOptionGroup;
export const selectSitePages = (state: any) => state.assetManagement.sitePages;
export const selectLoading = (state: any) => state.assetManagement.loading;

// Exporting reducer
export default assetManagementSlice.reducer;
